<template>
	<div class="main" >
		<div class="home pageItem"
			:style="{ backgroundImage: 'url(' + require('@/images/download/bgimg.png') + ')' }">
      <div class="downloadBox">
        <div class="downloadBoxZw" >
						<el-image class="smlogo" :src="require('@/images/download/logo.png')"></el-image>
            <div class="downloadBoxT">
              {{$t('download.shimida')}} <div class="downloadBoxTs">{{$t('download.gf')}}</div> 
            </div>
            <div class="verBox">
              <div>{{$t('download.chanpingongneng')}}</div>
              <div>{{$t('download.banben') + pageData.version }}<span style="margin-left: 10px;">{{ $t('download.daxiao') +pageData.filesize }}</span><span style="margin-left: 10px;"></span>{{$t('download.gengxin') + pageData.created_at }}</div>
              <div v-if="type=='ios'" class="tips">{{$t('download.tips')}}</div>
            </div>
					<el-image class="downloadimg" :class="type=='ios'?'':'downloadimgA'" :src="type=='ios'?require('@/images/home/qrcodeIos.png'):require('@/images/home/qrcodeAndroid.png')"></el-image>

          <div class="downloadtips" v-if="type=='ios'">{{$t('download.ios')}}</div>
          <div class="downloadtips" v-else>{{$t('download.anzhuo')}}</div>
          
          <div class="downloadBtn" @click="gotoDownLoadPage()">{{$t('download.xiazai')}}</div>
          <!-- <a :href="downHrefIos" class="downloadBtn" v-if="type=='ios'">下载安装</a> -->
          <!-- 下载前请务必....暂时关掉这个提示 -->
          <div class="downloadBtnTips" v-if="type=='ios'" @click="gotohelp()">{{$t('download.shouquan')}} >></div>

          <div class="BottomRowBox">
            <div class="BottomRow">{{$t('download.kaifazhe')}}</div>
            <div class="BottomRow">
              <a href="https://h5.smdchat.com/webRule?key=userAgreement" class="BottomRowRItem">{{$t('download.yonghuxieyi')}}</a>
              <a href="https://h5.smdchat.com/webRule?key=iosPrivacyPolicy" class="BottomRowRItem">{{$t('download.yinsizhengce')}}</a>
            </div>
          </div>
        </div>
      </div>


		</div>

	</div>
</template>
<script>
import { getVersionInfo,recordLogger } from '@/api/system'
export default {
	
	data() {
		return {
			pageindex:'1',
      type:'',
      downHrefIos:'',
      downHrefAndroid:'',
      pageData:{},
		}
	},
  mounted(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.type = this.getQueryVariable('type')
    this.getPageData()
  },

	methods:{
    getPageData(){
      getVersionInfo({agent:"all"}).then(res => {
        // console.log(res);
        if (this.type=="ios") {
          this.pageData=res.data.ios
        }else{
          this.pageData=res.data.android

        }
        this.downHrefIos=res.data.ios.download_url
        this.downHrefAndroid=res.data.android.download_url
      })
    },
    gotoDownLoadPage(type){
      if (this.type=='android') {
        window.location.href = this.downHrefAndroid
      }else if(this.type=='ios'){
        recordLogger({access_key :"h5_ios_download_click"}).then(res => {
          if (this.downHrefIos!="1") {
            window.location.href = this.downHrefIos
          }
        })
      }
		},
    gotohelp(){
			window.location.href = "https://h5.smdchat.com/ios_down?type=help"
    },

    //获取url参数
		getQueryVariable(value) {
			var query = window.location.search.substring(1);
			query = query.split("&");

			var data = {};

			for (var i = 0; i < query.length; i++) {
				var item = query[i].split("=");
				data[item[0]] = item[1]
			}

			if (value) {
				return data[value] ? data[value] : '';
			}

			return data;
		},
		changPage(e){
			// console.log(e);
			this.pageindex=e
		}
	},
};

</script>
<style>
body{
  margin: 0 !important;
}
</style>
<style scoped>

.main {
	width: 100vw;
	height: 100vh;
}

.pageItem {
	background-color: #fff;
	background-position: top;
	background-repeat: no-repeat;
	background-size: auto 100vh;
	width: 100vw;
	min-height: 100vh;
	/* height: 1800px; */
	position: relative;
	box-sizing: border-box;
}
.downloadBox{
  position: absolute;
  width: 528px;
height: 579px;
background: #FFFFFF;
border-radius: 24px;
top: 50%;
left: 50%;
transform: translate(-50%,-45%);

}
.downloadBoxZw{
  width: 100%;height: 100%;position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.smlogo{
  position: absolute;
  top: -60px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 120px;
  background: #3486FF;
  box-shadow: 0px 10px 40px 0px rgba(52,134,255,0.2);
  border-radius: 20px;
}
.downloadBoxT{
  margin-top: 78px;
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1F2626;
  line-height: 33px;
  display: flex;
  align-items: center;
}
.downloadBoxTs{
  width: fit-content;
  padding: 0 5px;
height: 20px;
background: #3486FF;
border-radius: 4px;
margin-left: 8px;
font-size: 12px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #FFFFFF;
line-height: 16px;
display: flex;
justify-content: center;
align-items: center;
}
.verBox{
  margin-top: 12px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  text-align: center;
}
.downloadimg{
  width: 160px;
  height: 160px;
  background: #F1F1F1;
  /* margin-top: 32px; */
}
.downloadimgA{
  margin-top: 32px;
}
.downloadtips{
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 24px;
  margin-top: 8px;
}
.downloadBtn{
  width: 312px;
  height: 48px;
  background: #3486FF;
  border-radius: 28px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 32px;
}
.downloadBtnTips{
  margin-top: 12px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FF5050;
  line-height: 16px;
}

.BottomRowBox{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 0 0 24px 24px ;

  margin-top: 10px;

}

.BottomRow{

  /* height: 40px; */
  /* background: #F5F8FB; */
  left: 0;
  bottom: 0;
  padding: 0 24px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;

}
.BottomRowL{
  
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #666666;
line-height: 20px;
max-width: 60%;
}
.BottomRowR{
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3486FF;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.BottomRowRItem{
  color: #3486FF;
  cursor: pointer;
  white-space: nowrap;
}
.tips{
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FF5050;
  line-height: 17px;
  margin: 12px 0;
  white-space: nowrap;
}

.el-image {
  overflow: visible;
}
</style>
  
  